var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDAppDevelopment = function SvgDAppDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 540 360"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 360,
    fill: "#FCF7F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m165.363 62.934-92.49 54.006A13.73 13.73 0 0 0 66 128.829v73.05c0 5.296 5.747 8.592 10.31 5.944l92.518-54.259a13.76 13.76 0 0 0 6.846-11.889V68.878c0-5.296-5.747-8.592-10.311-5.944"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m168.798 65.16-92.489 54.006a13.72 13.72 0 0 0-6.873 11.888v73.051c0 5.296 5.747 8.592 10.31 5.944l92.518-54.26a13.76 13.76 0 0 0 6.845-11.888V71.104c0-5.296-5.718-8.592-10.311-5.944"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__a)",
    d: "m168.798 65.16-92.489 54.006a13.72 13.72 0 0 0-6.873 11.888v73.051c0 5.296 5.747 8.592 10.31 5.944l92.518-54.26a13.76 13.76 0 0 0 6.845-11.888V71.104c0-5.296-5.718-8.592-10.311-5.944"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m224.985 261.879.11-.111c-.396-1.521.618-3.284 3.02-4.65l14.548-8.376a8 8 0 0 0 4.011-6.944v-6.987l27.024-15.694v4.828c0 3.085 3.328 5.003 5.995 3.46l6.436-3.703c3.703-2.138 9.258-2.535 12.41-.882l16.95 8.883c1.433.75 2.072 1.808 2.05 2.932.044 0 .044 4.034.044 4.034 0 1.344-1.124 2.821-3.174 3.989l-57.926 33.393c-3.703 2.138-9.258 2.535-12.41.882l-16.95-8.883c-2.711-1.631-2.138-3.835-2.138-6.171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__b)",
    d: "m224.985 261.879.11-.111c-.396-1.521.618-3.284 3.02-4.65l14.548-8.376a8 8 0 0 0 4.011-6.944v-6.987l27.024-15.694v4.828c0 3.085 3.328 5.003 5.995 3.46l6.436-3.703c3.703-2.138 9.258-2.535 12.41-.882l16.95 8.883c1.433.75 2.072 1.808 2.05 2.932.044 0 .044 4.034.044 4.034 0 1.344-1.124 2.821-3.174 3.989l-57.926 33.393c-3.703 2.138-9.258 2.535-12.41.882l-16.95-8.883c-2.711-1.631-2.138-3.835-2.138-6.171"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9398AC",
    d: "M246.676 231.417v-23.364l27.023-13.159v24.223l-27.023 15.694z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#81A0EA",
    d: "M246.631 231.527v-23.364l4.496-2.182v33.129c0 2.865-1.52 5.51-4.011 6.943l-3.152 1.807a8 8 0 0 0 2.645-5.929v-10.404z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "M225.095 261.681c-.132-.529-.044-1.103.155-1.654.286.75.837 1.455 1.851 2.072l16.95 8.883c3.13 1.653 8.685 1.257 12.41-.881l57.926-33.416c1.587-.926 2.601-2.006 2.997-3.064.111.309.155.618.155.926.044 0 .044 4.034.044 4.034 0 1.344-1.124 2.821-3.174 3.989l-57.926 33.394c-3.703 2.138-9.258 2.534-12.41.881l-16.95-8.883c-2.689-1.653-2.116-3.857-2.116-6.193z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__c)",
    d: "M225.095 261.681c-.132-.529-.044-1.103.155-1.654.286.75.837 1.455 1.851 2.072l16.95 8.883c3.13 1.653 8.685 1.257 12.41-.881l57.926-33.416c1.587-.926 2.601-2.006 2.997-3.064.111.309.155.618.155.926.044 0 .044 4.034.044 4.034 0 1.344-1.124 2.821-3.174 3.989l-57.926 33.394c-3.703 2.138-9.258 2.534-12.41.881l-16.95-8.883c-2.689-1.653-2.116-3.857-2.116-6.193z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#343C6B",
    d: "m343.748 58.94-4.453 100.511a19.2 19.2 0 0 1-9.566 16.619l-141.773 87.197c-6.414 3.726-18.956-.264-18.956-10.536V150.568a19.23 19.23 0 0 1 9.61-16.642L324.858 49.33c8.42-4.188 18.89 2.204 18.89 9.61"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m343.748 58.94-4.453 100.511a19.2 19.2 0 0 1-9.566 16.619l-141.773 87.197c-6.414 3.726-18.956-.264-18.956-10.536V150.568a19.23 19.23 0 0 1 9.61-16.642L324.858 49.33c8.42-4.188 18.89 2.204 18.89 9.61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M343.792 149.796v11.881a19.2 19.2 0 0 1-9.566 16.619l-146.292 84.972c-6.414 3.725-14.437-.904-14.437-8.31v-6.26z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "M173.497 152.794a19.23 19.23 0 0 1 9.61-16.642l146.27-84.596c6.414-3.703 14.415.926 14.415 8.332v89.93l-170.295 98.924z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M173.497 152.794a19.23 19.23 0 0 1 9.61-16.642l146.27-84.596c6.414-3.703 14.415.926 14.415 8.332v89.93l-170.295 98.924z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#819BEA",
    d: "M333.145 60.835v85.082l-149.002 86.536v-85.456z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5891",
    d: "M333.145 60.835v85.082l-149.002 86.536v-85.456z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "M202.271 183.81a2 2 0 0 0-.998 1.731v30.133c0 1.541 1.672 2.503 3.005 1.729l21.657-12.577a2 2 0 0 0 .995-1.73v-30.095c0-1.541-1.669-2.503-3.002-1.731z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__d)",
    d: "M202.271 183.81a2 2 0 0 0-.998 1.731v30.133c0 1.541 1.672 2.503 3.005 1.729l21.657-12.577a2 2 0 0 0 .995-1.73v-30.095c0-1.541-1.669-2.503-3.002-1.731z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "M304.98 96.71c0-1.54-1.668-2.501-3.001-1.73l-31.002 17.92a2 2 0 0 0-.999 1.732v30.088c0 1.542 1.67 2.504 3.004 1.73l31.002-18.001a2 2 0 0 0 .996-1.729z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__e)",
    d: "M304.98 96.71c0-1.54-1.668-2.501-3.001-1.73l-31.002 17.92a2 2 0 0 0-.999 1.732v30.088c0 1.542 1.67 2.504 3.004 1.73l31.002-18.001a2 2 0 0 0 .996-1.729z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDCC",
    d: "M264.644 117.381a.994.994 0 0 0-1.49-.86l-61.366 35.432a1.03 1.03 0 1 0 1.031 1.783l61.329-35.496a.99.99 0 0 0 .496-.859m0 8.442a.994.994 0 0 0-1.49-.86l-61.366 35.432a1.031 1.031 0 0 0 1.031 1.784l61.329-35.497a.99.99 0 0 0 .496-.859m0 8.442a.993.993 0 0 0-1.49-.859l-61.366 35.432a1.03 1.03 0 0 0 1.031 1.783l61.329-35.496a1 1 0 0 0 .496-.86m63.403-53.825a1.022 1.022 0 0 1 1.02 1.77l-16.854 9.724a1.03 1.03 0 1 1-1.03-1.786zm0 17.346a1.022 1.022 0 0 1 1.02 1.772l-16.854 9.723a1.03 1.03 0 1 1-1.03-1.786z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__f)",
    d: "M252.658 327.73c15.375 0 27.839-6.207 27.839-13.864s-12.464-13.864-27.839-13.864-27.839 6.207-27.839 13.864 12.464 13.864 27.839 13.864",
    opacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "m247.854 252.326 1.542 25.789c.067 1.41.309 2.821.706 4.166l6.105 23.452c-.705-.441-1.741-.926-2.49-.948-.265-.022-.507-.022-.75-.022h-.441a1.74 1.74 0 0 0-1.587 1.168 7 7 0 0 1-.066.309s0 1.719 2.116 3.284c.309.221.706.507 1.146.772a20 20 0 0 1 3.351 2.623c.573.529 1.234.925 2.094.969a2.157 2.157 0 0 0 2.27-2.292c-.022-.132-.022-.375-.044-.595-.022-.11-.022-.22-.044-.309-.022-.132-.022-.22-.044-.308-.088-.529-.176-1.146-.265-1.697-.22-1.279-.33-2.535-.396-3.814-.265-5.554-1.169-19.551-3.549-27.287l3.306-27.993z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "m239.082 315.012 4.143-.33a4.03 4.03 0 0 0 2.932-1.345 1.62 1.62 0 0 0 .353-1.411c-2.293-10.007-13.776-63.215-8.045-75.316 6.392-13.49 20.278-2.756 20.278-2.756s4.166 9.897 2.116 15.65c-1.852 5.18-9.919 7.34-9.919 7.34l-1.433 23.386c1.389 8.398 2.601 34.055 3.064 36.524.199 1.124-.022 2.689-.485 3.372-1.036 1.565-3.394 1.014-5.224.639l-5.4-1.058c-1.984-.397-3.284-1.785-3.637-2.997-.11-.816.441-1.543 1.257-1.698"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#535873",
    d: "M250.982 305.909a8 8 0 0 1-.066.309s0 1.058 1.014 2.248c-.088-1.08-.154-2.248-.243-3.439-.33.199-.573.507-.705.882"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M250.916 306.218s0 1.719 2.116 3.284c.309.22.705.507 1.146.771a20.2 20.2 0 0 1 3.351 2.623c.573.529 1.234.926 2.093.97 1.301.066 2.447-.353 2.271-2.292-.022-.133-.022-.375-.044-.595-.022-.111-.022-.221-.044-.309-.022-.154-.022-.22-.044-.309-.155.662-.882.816-1.433.794-.86-.044-1.609-.243-2.182-.772-1.036-.991-8.442-5.223-3.858-5.488l-.529-.088c-2.204-.265-2.534.463-2.777 1.146-.022.066-.066.176-.066.265"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M260.858 249.526c.816-2.292.661-5.224.154-7.935-.749-4.122-2.27-7.737-2.27-7.737s-13.357-10.47-20.278 2.755c-.662 1.279-1.147 2.954-1.433 4.96-3.02 19.551 9.191 70.159 9.191 70.159.177.353.64.595 1.235.749.11.044.22.066.33.088 1.565.287 3.792-.044 4.629-1.036 0 0-2.05-26.273-2.887-31.299l.044-.639c.11.904.308 1.807.573 2.667l5.554 21.843c.265.309.86.596 1.609.794.111.022.243.044.353.088 1.301.243 2.888.11 3.593-.838 0 0 .198-19.286-3.659-26.626z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "m250.013 270.841 1.08-18.934 4.21-1.852z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "m239.08 315.012 2.667-.22c-1.058.286-1.411 1.256-.353 2.006 1.213.837 11.131 2.226 11.176-.045.044.441.066.816.088.992.044.838-.133 1.698-.573 2.403-1.036 1.631-3.395 1.014-5.224.639l-5.401-1.058c-1.983-.397-3.284-1.785-3.636-2.998-.111-.837.44-1.565 1.256-1.719"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3E7",
    d: "M241.903 226.404s21.072 4.254 24.158-.308c1.366-2.05-6.238-24.555-6.238-24.555l-1.565-1.322-5.334 1.388c-.706.176-1.698-.904-1.698-.904.816 2.866 5.048 16.84 6.04 20.103.154.507-15.495 1.234-15.495 1.234 1.168.353 1.256 3.901.132 4.364"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBB2B8",
    d: "M250.94 200.858c-1.102 1.212-2.623 2.028-4.298 2.182a7.6 7.6 0 0 1-2.138-.287c-1.278-.352-3.461-1.058-4.563-1.432.375-.221.75-.463 1.125-.684l1.322-.771 4.805-2.777 3.02 1.036c1.102.418 1.521 1.851.727 2.733"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M237.649 191.931c1.389 5.841 5.334 6.259 8.927 4.364 4.034-2.116 6.37-7.009 6.48-10.536.177-5.378-3.306-8.751-7.759-8.905-10.139-.353-8.133 13.049-7.648 15.077"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBB2B8",
    d: "M250.675 188.69v11.705c0 .551-.507 1.08-1.432 1.41-1.609.595-3.858.441-5.048-.33-.485-.309-.705-.684-.705-1.08l-.022-11.705z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "m218.692 222.238-2.248 3.659a58 58 0 0 1-2.138-1.521c-.617-.154-1.962-.484-3.24-1.124-1.742-.881-2.16-3.218-.86-4.673l.22-.242s-1.565-1.433-1.939-1.763c-.419-.375-.595-.772-.419-1.08.331-.596.948-.309 1.455.044.97.661 3.879 2.601 3.879 2.601.375.264.727.595.992.969l.551.75a5.56 5.56 0 0 0 2.38 1.829c0-.022.507.221 1.367.551"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3E7",
    d: "m259.382 219.813.727-6.215 1.014-8.464c.044-5.952-4.033-8.354-8.133-7.825a8.1 8.1 0 0 0-2.336.617c-.309.132-2.756-1.212-3.086-1.058l-.397.242-3.791 2.182-1.014.574-1.323.771c-.374.22-.749.441-1.124.683-.088.044-.154.088-.242.133-1.852 1.124-3.373 2.182-4.519 3.438-1.124 1.234-1.851 2.689-2.116 4.629 0 0-1.763 14.9-2.094 16.597-.132.706-14.129-4.673-14.129-4.673-.925.331-2.028 2.469-1.807 3.417 0 0 15.782 11.528 20.984 7.715.441-.331.97-1.477 1.476-3.086.199 4.562-.815 8.265-.661 9.037 0 .066.022.088.044.11 5.577 4.078 21.866 3.042 23.717-1.477.243-.617-1.102-4.915-1.521-6.745-.771-3.526-.088-7.031.331-10.602"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#A99191",
    d: "M237.494 178.662c2.645-3.593 12.828-5.841 19.837-.419.353.286.662.617 1.058.837 1.764.948 3.351 2.623 4.343 4.85.859 1.939 1.168 3.989.992 5.885-.089.881.22 1.741.815 2.424a8.2 8.2 0 0 1 1.256 1.984c1.411 3.13.838 6.657-1.212 8.42a4 4 0 0 1-.793.573 4.4 4.4 0 0 1-1.058.419c.352 2.425-.331 4.761-1.874 6.084-.242.22-.507.418-.793.573-2.227 1.212-4.982.264-6.745-2.072-.088.044-.155.11-.243.154-3.659 2.006-8.376-.22-10.536-4.981-1.388-3.108-1.366-6.503-.154-9.06a8 8 0 0 1 .683-1.168c-1.278-1.256-2.27-2.799-2.931-4.364-.287-.683-.772-1.279-1.411-1.653-.132-.066-.242-.155-.375-.243-2.424-1.807-2.865-5.488-.859-8.243"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M240.491 190.586c-.926 1.235-1.036 2.733-.221 3.351.816.595 2.205.088 3.152-1.147.926-1.234 1.036-2.733.221-3.35-.816-.595-2.204-.088-3.152 1.146"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m197.117 157.378-37.356 21.806c-1.719.986-2.761 2.817-2.761 4.817v29.496c0 2.141 2.31 3.465 4.169 2.395l37.356-21.918a5.51 5.51 0 0 0 2.761-4.789v-29.384c0-2.169-2.31-3.493-4.169-2.423"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__g)",
    d: "m197.117 157.378-37.356 21.806c-1.719.986-2.761 2.817-2.761 4.817v29.496c0 2.141 2.31 3.465 4.169 2.395l37.356-21.918a5.51 5.51 0 0 0 2.761-4.789v-29.384c0-2.169-2.31-3.493-4.169-2.423"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m464.118 104.378-37.356 21.806c-1.719.986-2.761 2.817-2.761 4.817v29.496c0 2.141 2.31 3.465 4.169 2.395l37.356-21.918a5.51 5.51 0 0 0 2.761-4.789v-29.384c0-2.169-2.31-3.493-4.169-2.423"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__h)",
    d: "m464.118 104.378-37.356 21.806c-1.719.986-2.761 2.817-2.761 4.817v29.496c0 2.141 2.31 3.465 4.169 2.395l37.356-21.918a5.51 5.51 0 0 0 2.761-4.789v-29.384c0-2.169-2.31-3.493-4.169-2.423"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m182.133 234.573-56.907 33.215a8.47 8.47 0 0 0-4.226 7.325v44.934c0 3.268 3.522 5.297 6.339 3.663l56.907-33.384c2.592-1.521 4.198-4.31 4.198-7.297v-44.793c.028-3.24-3.493-5.297-6.311-3.663"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m185.569 236.715-56.908 33.214a8.47 8.47 0 0 0-4.225 7.325v44.935c0 3.268 3.521 5.296 6.338 3.662l56.908-33.384a8.49 8.49 0 0 0 4.197-7.297v-44.793c.029-3.24-3.493-5.296-6.31-3.662"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__i)",
    d: "m185.569 236.715-56.908 33.214a8.47 8.47 0 0 0-4.225 7.325v44.935c0 3.268 3.521 5.296 6.338 3.662l56.908-33.384a8.49 8.49 0 0 0 4.197-7.297v-44.793c.029-3.24-3.493-5.296-6.31-3.662"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m400.133 64.573-56.907 33.215a8.47 8.47 0 0 0-4.226 7.325v44.934c0 3.268 3.522 5.297 6.339 3.663l56.907-33.384c2.592-1.521 4.198-4.31 4.198-7.297V68.236c.028-3.24-3.493-5.297-6.311-3.663"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m403.569 66.715-56.908 33.214a8.47 8.47 0 0 0-4.225 7.325v44.935c0 3.268 3.521 5.296 6.338 3.662l56.908-33.384a8.49 8.49 0 0 0 4.197-7.297V70.377c.029-3.24-3.493-5.296-6.31-3.662"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__j)",
    d: "m403.569 66.715-56.908 33.214a8.47 8.47 0 0 0-4.225 7.325v44.935c0 3.268 3.521 5.296 6.338 3.662l56.908-33.384a8.49 8.49 0 0 0 4.197-7.297V70.377c.029-3.24-3.493-5.296-6.31-3.662"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppDevelopment_svg__k)",
    d: "M367.096 273.168c15.375 0 27.838-6.207 27.838-13.864s-12.463-13.865-27.838-13.865-27.839 6.208-27.839 13.865 12.464 13.864 27.839 13.864",
    opacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M322.064 120.264c.154-.265.264-.507.264-.507-.286-.838-2.645-2.976-2.292-3.439 1.102-1.41 5.841 3.99 5.841 3.99s-.507-1.455-.705-1.918c-.221-.529-.044-1.124.242-1.322.573-.397 1.212.308 1.345.705l1.763 3.13c.242.419.397.882.485 1.367l.176.947c.199 1.036 1.102 2.932 1.345 3.659l-1.124 4.254c-.243-.617-3.174-4.188-3.681-4.606-.75-.595-1.543-1.213-2.183-1.94 0 0-1.609-1.675-1.719-2.513-.132-.617-.066-1.256.243-1.807"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M368.066 249.473s0 1.786 2.183 3.395c.308.22.727.507 1.168.793 1.234.772 2.909 2.226 3.989 3.24.595.551 1.257.948 2.16.992 1.345.066 2.513-.352 2.337-2.38-.022-.133-.022-.375-.044-.618-.022-.11-.022-.22-.044-.33-.022-.154-.11-3.879-.133-3.968-.154.684-1.102-1.961-1.675-1.983-.881-.045-.749 2.049-1.344 1.498-1.058-1.014-2.204-.551-5.136-2.049l-.551-.089c-2.27-.264-2.623.485-2.843 1.169a5 5 0 0 1-.067.33m-17.103 9.214s2.05-.199 2.733-.221c1.609-.066 5.158-1.08 6.26-.308 1.256.859 4.056 1.587 4.078-.75l1.587.507c.022.507.176 3.395.176 3.593.044.86-.132 1.741-.595 2.469-1.058 1.675-4.342.705-6.216.308l-5.621-.749c-2.049-.419-3.372-1.852-3.747-3.086-.066-.86.529-1.631 1.345-1.763"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDF1",
    d: "m380.74 178.058.661 2.424c.154.595.287 1.213.331 1.83.286 2.909.308 5.841.11 8.772l-.463 6.393-1.455 52.547c.132 2.116-6.899 2.315-6.877-.198l-1.411-54.466-1.983.772-3.791 61.497c0 2.16-7.032 2.38-7.12-.243 0 0-2.072-62.51-2.314-72.319-.177-6.899 12.387-5.048 12.387-5.356l-6.502-5.092z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M363.195 167.543s23.034 4.1 26.274-.948c1.455-2.27-7.097-25.414-7.097-25.414l-2.05-2.535-5.775 1.654c-.772.22-1.874-.948-1.874-.948.948 3.108 5.907 18.184 7.076 21.711.176.551-16.818 1.719-16.818 1.719 1.3.375 1.498 4.232.264 4.761"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "m380.873 167.896.683 11.727c-.308 5.951-24.268 7.053-26.185 3.063-.375-.771 0-9.896.286-15.892a38.3 38.3 0 0 0-.948-10.381 17 17 0 0 1-.132-.507c-.529-2.249-1.984-4.144-4.034-5.18-2.953-1.521-9.103-4.1-11.065-5.004a7.8 7.8 0 0 1-3.063-2.49l-9.743-12.829c-1.08-1.3 3.637-5.334 4.893-4.342l11.286 11.947 6.546 2.16a8.8 8.8 0 0 0 4.475.33c2.887-.573 5.819-.154 5.995-.22a14.4 14.4 0 0 0 2.888-1.212c.771-.419 1.322-.728 1.322-.728l.132-.044 4.012-2.138.309-.154c.154-.088.815.22 1.476.529.684.331 1.389.661 1.609.661.926-.33 1.83-.551 2.734-.595a9 9 0 0 1 1.058 0c3.835.198 7.648 2.777 7.472 7.913l-1.984 20.499a21 21 0 0 0-.022 2.887"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M373.379 139.418c0 1.874-3.064 3.417-6.855 3.417-3.196 0-5.885-1.102-6.634-2.579a15.7 15.7 0 0 0 2.887-1.212c.772-.419 1.323-.728 1.323-.728l.132-.044 4.012-2.138c.639.088 1.256.198 1.807.375a7.6 7.6 0 0 1 1.609.661c1.058.595 1.719 1.389 1.719 2.248m-14.615-8.42c1.147 5.665 4.916 6.216 8.465 4.497 3.945-1.918 6.37-6.547 6.612-9.941.353-5.18-2.909-8.552-7.186-8.839-9.764-.683-8.287 12.3-7.891 14.283"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "m371.461 128.309-.397 11.286c-.022.529-.529 1.014-1.432 1.3-1.565.507-3.726.287-4.85-.507-.463-.331-.661-.683-.661-1.058l.375-11.285z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M366.942 123.901c-1.234 1.631-3.086 2.468-4.849 2.38-.573-.022-1.124-1.41-1.829-2.226-.463-.529-1.191-.507-1.477-.771-1.279-1.124-1.477-5.202 1.366-6.833a11 11 0 0 1 7.517-1.257c.286.044-1.521.926-1.301 1.102 2.248 1.72 2.491 5.114.573 7.605"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "m368.11 132.387-.838-3.373a5.45 5.45 0 0 0-1.278-2.38 5.5 5.5 0 0 0-2.336-1.499l-3.373-1.08c.199 2.843 1.411 5.18 4.034 7.957 1.256 1.345 2.623 2.138 3.923 2.425l.022-.551c.022-.485-.044-.992-.154-1.499"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M367.691 115.216c-4.1-.375-7.45 2.998-7.472 7.957 0 .309.022.595.044.882l3.372 1.08a5.3 5.3 0 0 1 2.337 1.499 5.6 5.6 0 0 1 1.278 2.38l.838 3.373c.132.485.176 1.014.154 1.521l-.022.551c2.513.573 5.4-1.301 6.37-4.828.529-1.851 5.026-13.335-6.899-14.415"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M361.565 129.808c-.948 1.168-1.08 2.601-.331 3.218s2.138.154 3.064-.992c.948-1.168 1.08-2.601.33-3.218-.749-.617-2.116-.176-3.063.992"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__a",
    x1: 124.272,
    x2: 124.272,
    y1: 64.226,
    y2: 210.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__b",
    x1: 271.259,
    x2: 271.259,
    y1: 219.117,
    y2: 277.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__c",
    x1: 225.923,
    x2: 241.253,
    y1: 266.321,
    y2: 219.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__d",
    x1: 224.966,
    x2: 196.705,
    y1: 219.374,
    y2: 172.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__e",
    x1: 302.301,
    x2: 274.383,
    y1: 148.445,
    y2: 90.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__g",
    x1: 160.389,
    x2: 187.472,
    y1: 216.541,
    y2: 151.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__h",
    x1: 427.39,
    x2: 454.473,
    y1: 163.541,
    y2: 98.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__i",
    x1: 158.158,
    x2: 158.158,
    y1: 236.141,
    y2: 326.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppDevelopment_svg__j",
    x1: 376.158,
    x2: 376.158,
    y1: 66.141,
    y2: 156.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dAppDevelopment_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 13.8643 -27.8388 0 252.658 313.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10134A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10134A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dAppDevelopment_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 13.8643 -27.8388 0 367.096 259.304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10134A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10134A",
    stopOpacity: 0
  })))));
};
export default SvgDAppDevelopment;